import "./gallery_overlay_asset.scss";

/*
  Leaving JavaScript as CoffeeScript until all component usages of gallery_overlay_asset are refactored to Komponent,
    to avoid duplicate or conflicting code.
*/
